import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { v as version } from './package.js';
import { g as getAttributeObserver } from './attribute-observer.js';
import { d as defineCustomElement$2 } from './post-popovercontainer2.js';

const postPopoverCss = "/*!\n * Bootstrap Utilities v5.1.3 (https://getbootstrap.com/)\n * Copyright 2011-2021 The Bootstrap Authors\n * Copyright 2011-2021 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n\n * The MIT License (MIT)\n\n * Copyright (c) 2011-2020 Twitter, Inc.\n * Copyright (c) 2011-2020 The Bootstrap Authors\n\n * Permission is hereby granted, free of charge, to any person obtaining a copy\n * of this software and associated documentation files (the \"Software\"), to deal\n * in the Software without restriction, including without limitation the rights\n * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n * copies of the Software, and to permit persons to whom the Software is\n * furnished to do so, subject to the following conditions:\n\n * The above copyright notice and this permission notice shall be included in\n * all copies or substantial portions of the Software.\n\n * THE SOFTWARE IS PROVIDED \"AS IS\", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN\n * THE SOFTWARE.\n *//*!\n * Copyright 2021 by Swiss Post, Information Technology\n */.btn-close{padding:0;overflow:visible;border:0;background:none;color:inherit;font:inherit;-webkit-user-select:none;user-select:none;appearance:button;border-radius:4px;color:var(--post-gray-80);transition:opacity 250ms,border-color 250ms,background-color 250ms,color 250ms;cursor:pointer}.btn-close{outline-style:none !important;outline-offset:2px !important;outline-width:2px !important;outline-color:var(--post-focus-color) !important}.btn-close:is(:focus-visible,:has(:focus-visible),.pretend-focus){outline-style:solid !important;border-radius:4px}@media (forced-colors: active),(-ms-high-contrast: active),(-ms-high-contrast: white-on-black){.btn-close:is(:focus-visible,:has(:focus-visible),.pretend-focus){outline-color:Highlight !important}}@supports not selector(:has(:focus-visible)){.btn-close:is(:focus-visible,:focus-within,.pretend-focus){outline-style:solid !important;border-radius:4px}@media (forced-colors: active),(-ms-high-contrast: active),(-ms-high-contrast: white-on-black){.btn-close:is(:focus-visible,:focus-within,.pretend-focus){outline-color:Highlight !important}}}.btn-close::before{-webkit-mask-image:url(\"data:image/svg+xml,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m16.267 16.667 6.667-6.533-.933-1.067-6.667 6.667-6.667-6.667-.933 1.067 6.667 6.533-6.667 6.667 1.067.933 6.533-6.667 6.667 6.667.933-1.067z'/%3E%3C/svg%3E\");mask-image:url(\"data:image/svg+xml,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m16.267 16.667 6.667-6.533-.933-1.067-6.667 6.667-6.667-6.667-.933 1.067 6.667 6.533-6.667 6.667 1.067.933 6.533-6.667 6.667 6.667.933-1.067z'/%3E%3C/svg%3E\");background-color:currentColor;color:currentColor;forced-color-adjust:preserve-parent-color;content:\"\";display:block;height:1.5rem;width:1.5rem}:where(.bg-dark,.bg-black,.bg-primary,.bg-secondary,.bg-success,.bg-error,.bg-nightblue,.bg-nightblue-bright,.bg-petrol,.bg-coral,.bg-olive,.bg-purple,.bg-purple-bright,.bg-aubergine,.bg-aubergine-bright,.alert-primary,post-alert[type=primary],.alert-success,post-alert[type=success],.alert-danger,post-alert[type=danger],.alert-notification,post-alert[type=notification],.alert-error,post-alert[type=error]) .btn-close{color:var(--post-contrast-color)}.btn-close:focus,.btn-close:not(:disabled):hover,.pretend-hover.btn-close{color:var(--post-contrast-color)}.btn-close:disabled{color:var(--post-gray-40)}@media (forced-colors: active),(-ms-high-contrast: active),(-ms-high-contrast: white-on-black){.btn-close{color:CanvasText;forced-color-adjust:none}.btn-close:focus,.btn-close:not(:disabled):hover,.pretend-hover.btn-close{color:Highlight}}.btn-close-white{color:#e6e6e6}.btn-close-white:focus,.btn-close-white:not(:disabled):hover,.btn-close-white.pretend-hover{color:#fff}.btn-close-white:disabled{color:#999}*{box-sizing:border-box}:host{--post-contrast-color:#fff;--post-bg-rgb:51, 51, 51;display:block}.visually-hidden{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);border:0}.popover-container{display:flex;align-items:self-start;padding:.5em;min-width:160px;max-width:280px}@media (max-width: 599.98px){.popover-container{max-width:100%}}.popover-content{padding:.5em;flex-grow:1}.btn-close{color:inherit}";
const PostPopoverStyle0 = postPopoverCss;

/**
 * @slot default - Slot for placing content inside the popover.
 */
let popoverInstances = 0;
const popoverTargetAttribute = 'data-popover-target';
const globalToggleHandler = (e) => {
    let currentElement = e.target;
    // Traverse up the DOM tree to find if any parent has the popover target attribute
    while (currentElement && !currentElement.getAttribute(popoverTargetAttribute)) {
        if (currentElement === document.body || !currentElement.parentElement)
            break;
        currentElement = currentElement.parentElement;
    }
    const popoverTarget = currentElement === null || currentElement === void 0 ? void 0 : currentElement.getAttribute(popoverTargetAttribute);
    if (!popoverTarget || ('key' in e && e.key !== 'Enter'))
        return;
    const popover = document.getElementById(popoverTarget);
    popover === null || popover === void 0 ? void 0 : popover.toggle(currentElement);
};
// Initialize a mutation observer for patching accessibility features
const triggerObserver = getAttributeObserver(popoverTargetAttribute, trigger => {
    const force = trigger.hasAttribute(popoverTargetAttribute);
    trigger.setAttribute('aria-expanded', force ? 'false' : null);
});
const PostPopover$1 = /*@__PURE__*/ proxyCustomElement(class PostPopover extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.placement = 'top';
        this.closeButtonCaption = undefined;
        this.arrow = true;
        this.localBeforeToggleHandler = this.beforeToggleHandler.bind(this);
    }
    connectedCallback() {
        // Set up accessibility patcher and event listeners for the first component
        if (popoverInstances === 0) {
            window.addEventListener('pointerup', globalToggleHandler);
            window.addEventListener('keydown', globalToggleHandler);
            triggerObserver.observe(document.body, {
                subtree: true,
                childList: true,
                attributeFilter: [popoverTargetAttribute],
            });
        }
        popoverInstances++;
        this.triggers.forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
    }
    componentDidLoad() {
        this.popoverRef.addEventListener('beforetoggle', this.localBeforeToggleHandler);
    }
    disconnectedCallback() {
        popoverInstances--;
        // Remove listeners and observer after the last popover has been destructed
        if (popoverInstances === 0) {
            window.removeEventListener('click', globalToggleHandler);
            window.removeEventListener('keydown', globalToggleHandler);
            triggerObserver.disconnect();
        }
        this.popoverRef.removeEventListener('beforetoggle', this.localBeforeToggleHandler);
        this.triggers.forEach(trigger => trigger.removeAttribute('aria-expanded'));
    }
    /**
     * Programmatically display the popover
     * @param target An element with [data-popover-target="id"] where the popover should be shown
     */
    async show(target) {
        this.popoverRef.show(target);
        target.setAttribute('aria-expanded', 'true');
    }
    /**
     * Programmatically hide this popover
     */
    async hide() {
        this.popoverRef.hide();
        this.triggers.forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
    }
    /**
     * Toggle popover display
     * @param target An element with [data-popover-target="id"] where the popover should be anchored to
     * @param force Pass true to always show or false to always hide
     */
    async toggle(target, force) {
        const newState = await this.popoverRef.toggle(target, force);
        this.triggers.forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
        target.setAttribute('aria-expanded', `${newState}`);
    }
    get triggers() {
        return document.querySelectorAll(`[${popoverTargetAttribute}="${this.host.id}"]`);
    }
    beforeToggleHandler() {
        this.triggers.forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
    }
    render() {
        return (h(Host, { key: '8c32a2546f820437af18636ba641ecea731aa753', "data-version": version }, h("post-popovercontainer", { key: '153a80377f98777f0b2ac25d3c8671acd15826df', arrow: this.arrow, placement: this.placement, ref: e => (this.popoverRef = e) }, h("div", { key: 'c639c0f2b76a18f8f9cc24def68c8b96e4ab94e7', class: "popover-container" }, h("div", { key: 'a0e8941ad78df9443aea7a926f0f9cba31df3a90', class: "popover-content" }, h("slot", { key: '00ea323cc3c59e5933c70a3af65ee01e119f8a77' })), h("button", { key: 'c73f56292364327acaa4a5114a62e43b76bdc81c', class: "btn-close", onClick: () => this.hide() }, h("span", { key: 'fd711fe7605961881c999523ecfbeaa1dc2f081a', class: "visually-hidden" }, this.closeButtonCaption))))));
    }
    get host() { return this; }
    static get style() { return PostPopoverStyle0; }
}, [1, "post-popover", {
        "placement": [1],
        "closeButtonCaption": [1, "close-button-caption"],
        "arrow": [4],
        "show": [64],
        "hide": [64],
        "toggle": [64]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["post-popover", "post-popovercontainer"];
    components.forEach(tagName => { switch (tagName) {
        case "post-popover":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PostPopover$1);
            }
            break;
        case "post-popovercontainer":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const PostPopover = PostPopover$1;
const defineCustomElement = defineCustomElement$1;

export { PostPopover, defineCustomElement };
